module.exports = __webpack_public_path__ + "img/banner.086059fb.png";